module.exports = __webpack_public_path__ + "img/title.b5c18bb7.png";